import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String }

  visit(event) {
    // Don't navigate if clicking on a link or button inside the row
    if (event.target.closest("a, button")) return

    Turbo.visit(this.urlValue)
  }

  handleKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      Turbo.visit(this.urlValue)
    }
  }
}
